import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useFormikContext } from "formik";
import { constants } from "@qgiv/core-js";
import { Button } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";

const CreateTeamFooter = ({
    setAppTeamModalOpen,
    updateTeams,
    submitButtonLabel,
    teamRegistrantLimit,
}) => {
    const dispatch = useDispatch();
    const {
        setFieldValue,
        values: {
            New_Team_Name = "",
            New_Team_Fundraising_Goal = "",
            Registration_Role = "",
        },
        errors,
    } = useFormikContext();
    const {
        ENUMS: {
            EntityType: { TEAM },
        },
    } = constants;
    const newTeam = {
        id: "new-team",
        title: New_Team_Name,
        captains: [],
        // if there are classification team registrant limits, need to add that here
        ...(teamRegistrantLimit > 0 && { remainingSpots: teamRegistrantLimit }),
    };
    const hasNameAndGoalValues =
        New_Team_Name.length > 0 && New_Team_Fundraising_Goal.length > 0;
    const hasNameOrGoalError =
        Boolean(errors.New_Team_Name) ||
        Boolean(errors.New_Team_Fundraising_Goal);
    const disabled = !hasNameAndGoalValues || hasNameOrGoalError;

    return (
        <div className="col col--12">
            {/* eslint-disable-next-line tailwindcss/classnames-order */}
            <div className="grid grid--justify-content-center">
                <div className="col col--md-8 col--12 -text--center">
                    <Button
                        classes={cx("-width--80", disabled && "-disabled")}
                        btnStyle="primary"
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            dispatch(updateTeams([{ ...newTeam }]));
                            setFieldValue("Team", "new-team");
                            setFieldValue("Team_Captain", true);
                            if (Registration_Role[0] !== TEAM) {
                                setFieldValue("Registration_Role", [`${TEAM}`]);
                            }
                            dispatch(setAppTeamModalOpen(false));
                        }}
                        // Prevent saving without a team name
                        disabled={disabled}
                    >
                        {submitButtonLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};

CreateTeamFooter.propTypes = {
    setAppTeamModalOpen: PropTypes.func.isRequired,
    submitButtonLabel: PropTypes.string.isRequired,
    teamRegistrantLimit: PropTypes.number.isRequired,
    updateTeams: PropTypes.func.isRequired,
};

export default CreateTeamFooter;
